module.exports = __webpack_public_path__ + "assets/Psi.7c6a0795c23dd3a6b0f39dbb8b9934cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Psi.png
// module id = 796
// module chunks = 0